export const POSITIONTYPECIRCLEATORBREADCRUMB = 'POSITION_TYPE_CIRCLEATOR_BREADCRUMB';

export interface PositionTypeCircleatorBreadcrumb {
  type: typeof POSITIONTYPECIRCLEATORBREADCRUMB;
  data: any;
}